export default "__VITE_ASSET__CQ8Gp9fX__";